module.exports = __webpack_public_path__ + "img/xj1.1cbdfc34.png";